<template>
  <section class="hbox stretch">
    <div class="content-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>营销</el-breadcrumb-item>
        <el-breadcrumb-item>拼团订单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true">
        <el-row>
          <el-col :span="3"> <el-input placeholder="单据号" v-model="queryParam.billNumber" size="small" clearable></el-input></el-col>
          <el-col :span="3" style="margin-left:5px"><el-input  placeholder="项目名称" v-model="queryParam.title" size="small" clearable></el-input></el-col>
          <el-col :span="3" style="margin-left:5px"><el-input  placeholder="商家名称" v-model="queryParam.merchantName" size="small" clearable></el-input></el-col>
          <el-col :span="2" style="margin-left:5px"><el-input  placeholder="会员编号" v-model="queryParam.number" size="small" clearable></el-input></el-col>
          <el-col :span="2" style="margin-left:5px">
            <el-select v-model="queryParam.state" size="small" placeholder="请选择状态" clearable>
              <el-option label="请选择" value=""></el-option>
              <el-option label="已取消" value="-3"></el-option>
              <el-option label="申请取消" value="-2"></el-option>
              <el-option label="未支付" value="-1"></el-option>
              <el-option label="支付完成" value="0"></el-option>
              <el-option label="待使用" value="3"></el-option>
              <el-option label="完成" value="4"></el-option>
            </el-select>
          </el-col>
          <el-col :span="8" style="margin-left:5px">
            <el-date-picker
              v-model="queryParam.date"
              size="small" 
              type="daterange"
              align="right"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"                
              end-placeholder="结束日期"
              @change="dateSelect"
              >
            </el-date-picker>
          </el-col>
        
          <el-col :span="2" style="margin-left:5px"><el-button type="primary" v-on:click="Search" size="small" >查询</el-button></el-col>
        </el-row>
      </el-form>
      <el-table :data="groupbookings" style="width: 100%">
        <el-table-column  prop="BillNumber" width="130px" fixed="left" label="单据号"> </el-table-column>
        <el-table-column  prop="Title" :show-overflow-tooltip="true" label="名称"> </el-table-column>
        <el-table-column  prop="MerchantName" :show-overflow-tooltip="true"  label="所属商家"> </el-table-column>        
        <el-table-column  prop="MemberName"  label="会员" ></el-table-column>
        <el-table-column  prop="OriginalPrice"  label="原价"> </el-table-column>
        <el-table-column  prop="PreferentialFee"  label="拼团价"> </el-table-column>
        <el-table-column  prop="Number"  label="数量"> </el-table-column>
        <el-table-column  prop="UserAccount"  label="操作员" ></el-table-column>
        <el-table-column  prop="CreateTime"  label="创建时间" ></el-table-column>
        <el-table-column  prop="State"  label="状态" > 
          <template slot-scope="scope">                    
            <p v-if="scope.row.State==-3">已取消</p>
            <p v-if="scope.row.State==-2">申请取消</p>
            <p v-if="scope.row.State==-1">未支付</p>
            <p v-if="scope.row.State==0">支付完成</p>
            <p v-if="scope.row.State==3">待使用</p>
            <p v-if="scope.row.State==4">完成</p>
          </template>
        </el-table-column>        
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParam.pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryParam.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryParam.totalCount">
      </el-pagination>
    </div>   
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        groupbookings:[],
        queryParam:{
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          sort:' CreateTime desc ',
          billNumber:'',
          title:'',
          merchantName:'',
          number:'',
          state:'',
          beginTime:'',
          endTime:'',
          date:''
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/groupbooking/Order',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.groupbookings = resp.data.items
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val
        this.GetData()
      },
      dateSelect(picker){
        if(picker==null){
          this.queryParam.beginTime = ''
          this.queryParam.endTime = ''
        }else{
          this.queryParam.beginTime = picker[0]
          this.queryParam.endTime = picker[1]
        }
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>